/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsUserWorker: {
  name: 'user-worker';
  data: string;
} = {
  name: 'user-worker',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 2a1 1 0 1 0-2 0v.28l-1.069.355A1 1 0 0 0 8 3v3a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2V3a1 1 0 0 0-1.931-.365L13 2.28V2Zm-3 3v1h4V4.72l-1.069-.355a1 1 0 0 1-1.862 0L10 4.72V5Zm.114 4.667a1 1 0 0 0-1.886.666 4.001 4.001 0 0 0 7.544 0 1 1 0 0 0-1.886-.666 2.001 2.001 0 0 1-3.772 0ZM7 22a5 5 0 0 1 10 0 1 1 0 1 0 2 0 7 7 0 1 0-14 0 1 1 0 1 0 2 0Z" fill="currentColor"/></svg>`,
};
